import { combineReducers } from 'redux'
import modelDataReducer from './modelDataReducer'

export default combineReducers({
    modelData: modelDataReducer
})